/**
 * Share List is a modal component which comes up on the click of share icon on List Details Page
 */

import globals from '../../common/globals';
import ManageProfileShoppingListService from '../../common/services/manage-profile-shopping-lists-service';
import {
  Validator,
} from 'vee-validate';
import detectDeviceMixin from '../../common/mixins/detect-device-mixin';

const defaultRecipients = [];
export default {
  name: 'vx-share-list',
  mixins: [detectDeviceMixin],
  props: {
    // text coming from property file
    i18n: {
      type: Object,
    },
    // Wishlist id coming from parent component
    wishlistId: {
      type: String,
      default: '',
    },
    // List id coming from parent component
    listId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      globals,
      manageProfileShoppingListService: new ManageProfileShoppingListService(),
      recipients: defaultRecipients,
      recipientValue: defaultRecipients.join(),
    };
  },
  watch: {
    recipientValue(val) {
      this.recipients = val.split(',').map(value => value.trim());
    },
  },
  computed: {

  },
  mounted() {
    const veeCustomErrorMessage = {
      en: {
        custom: {
          recipients: {
            required: this.i18n.shareList.shareListRequired,
            email: this.i18n.shareList.shareListError,
          },
        },
      },
    };
    Validator.localize(veeCustomErrorMessage);
  },
  methods: {
    /**
     * Function called on click of share icon which share that list
     */
    onSubmit() {
      const self = this;
      self.$validator.validateAll().then((result) => {
        if (result) {
          const requestConfig = {};
          requestConfig.params = self.createRequestbody();
          self.manageProfileShoppingListService.shareList(requestConfig, self.handleShareListResponse, self.handleShareListError, this.wishlistId);
        } else {
          this.globals.setFocusByName(this.$el, this.globals.getElementName(this.errors));
        }
      });
    },
    /**
     * Function creates the request body for share list service call
     */
    createRequestbody() {
      const requestBody = {
        wishlistId: this.wishlistId,
        recipientemails: this.recipients.toString(),
      };
      return requestBody;
    },
    /**
     * Function handles response of the share list service call
     */
    handleShareListResponse(response) {
      if (response) {
        this.$emit('share-list-success', this.i18n.listDetails.shareItemResponse);
      }
    },
    /**
     * Function handles error of the share list service call
     */
    handleShareListError(error) {
      if (error) {
        this.$emit('share-list-error', error.response.data.errors[0].message);
      }
    },
    /**
     * Function sets the cart id
     * @param  {String}   cartId string of cart id
     */
    setCartId(cartId) {
      this.shareCartId = cartId;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/manage-profile-shopping-lists/vx-share-list/vx-share-list.js